import React, { useState } from 'react';

import { useMatch } from 'react-router-dom';

import { Box, Collapse, IconButton, Stack, Typography } from '@mui/material';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import PropTypes from 'prop-types';

import { COLORS } from '../Constant/COLORS';

import { useIsMobile } from '../Hooks/useIsMobile';

const MobileWrapperFooterDropDown = ({ children, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  const isRegisterProfessional = useMatch('/professional');

  const isMobile = useIsMobile();

  return isMobile ? (
    <Box maxWidth='80%' mx='auto' py={0.5} px={1}>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Typography
          color={isRegisterProfessional ? 'white' : COLORS.grey2}
          fontWeight={600}
          flexGrow='1'
        >
          {title}
        </Typography>
        <IconButton onClick={() => setIsOpen(currentState => !currentState)}>
          {isOpen ? (
            <KeyboardArrowUpIcon
              style={{ color: isRegisterProfessional ? 'white' : COLORS.grey2 }}
            />
          ) : (
            <KeyboardArrowDownIcon
              style={{ color: isRegisterProfessional ? 'white' : COLORS.grey2 }}
            />
          )}
        </IconButton>
      </Stack>
      <Collapse in={isOpen}>{children}</Collapse>
    </Box>
  ) : (
    children
  );
};

MobileWrapperFooterDropDown.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default MobileWrapperFooterDropDown;
